import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BrightnessLowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_low"}/>
}
